<template>
  <div ref="container" style="height:100%;position: relative;overflow-y: auto;">
    <div style="padding: 0px;background-color: #fff">
      <div  class="block" style="padding-top: 0px;padding-bottom: 0px;" >
        <a-tabs v-model:activeKey="tab_activeKey" @change="changeTabPage">
          <a-tab-pane v-permission="'assetType'" key="assetType" tab="资产类型"></a-tab-pane>
          <a-tab-pane v-permission="'assetBrand'" key="assetBrand" tab="资产品牌"></a-tab-pane>
        </a-tabs>
      </div>

      <div class="block" style="" >
        <transition mode="out-in" leave-active-class="cmp-out" enter-active-class="cmp-in">
          <Component :is="cmpObj"/>
        </transition>
      </div>


    </div>
  </div>
</template>

<script setup>
import {defineAsyncComponent, ref, shallowRef} from "vue";
/** 异步加载组件 **/
const AssetTypeManage = defineAsyncComponent(() =>{
  return import('@/components/_assetTypeManage.vue')
})
/** 异步加载组件 **/
const AssetBrandManage = defineAsyncComponent(() =>{
  return import('@/components/_assetBrandManage.vue')
})

const tab_activeKey = ref("assetType");
const cmpObj = shallowRef(AssetTypeManage);

const changeTabPage = ()=>{
  if (tab_activeKey.value === "assetType"){
    cmpObj.value = AssetTypeManage;
  }else if(tab_activeKey.value === "assetBrand"){
    cmpObj.value = AssetBrandManage;
  }

}

</script>

<style scoped>
.block{
  box-sizing:border-box;
  padding-left: 10px;
  padding-right: 10px;
}
.cmp-in {
  animation: fadeIn;
  animation-duration: 0.2s; /* don't forget to set a duration! */
}
.cmp-out{
  animation: fadeOut;
  animation-duration: 0.2s;
}
</style>
